import React from "react";
import { Link } from "react-router-dom";
import { IBaseEcg } from "../../../../models/base-ecg.interface";
import { RouteConstants as routes } from "../../../../constants";
import EcgDateTime from "../../../Shared/EcgDateTime/EcgDateTime";
import UrgentIcon from "../../../Shared/UrgentIcon/UrgentIcon";
import styles from "./UserEcgListItem.module.css";
import CircleIndicator from "../../../Shared/CircleIndicator/CircleIndicator";

type UserEcgListItemProps = {
  ecg: IBaseEcg;
  patientId: string | null;
  selected?: boolean;
  onClick?: (ecg: IBaseEcg) => void;
};

const UserEcgListItem = ({
  ecg,
  patientId,
  selected,
  onClick,
}: UserEcgListItemProps) => {
  const { date, id, unviewedEcg, isUrgent } = ecg;
  const clickHandler = () => {
    if (onClick) onClick(ecg);
  };

  return (
    <Link
      className={styles.link}
      to={`/${routes.PATIENTS}/${patientId}/${routes.ECGS}/${id}`}
      onClick={clickHandler}
    >
      <div
        className={`${styles.row} ${
          selected ? styles.selected : ""
        } w-100 d-flex align-items-center`}
      >
        <div className={`${styles.imgWrapper}`}>
          {isUrgent && <UrgentIcon />}
        </div>
        <div className="flex-grow-1">
          <div
            className={`${styles.ecgDetails} d-flex align-items-center justify-content-between p-1`}
          >
            <EcgDateTime date={date} showTime />
            <div className="d-flex align-items-center mx-1">
              <CircleIndicator
                className={unviewedEcg ? "prim-bg-color" : "bg-transparent"}
              />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default UserEcgListItem;
